module.exports = __webpack_public_path__ + "static/img/4.d8eeee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/4.jpg
// module id = j/Ls
// module chunks = 1